"use strict";

var _toConsumableArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dates_1 = require("react-dates");

require("react-dates/initialize");

require("react-dates/lib/css/_datepicker.css");

var moment_1 = tslib_1.__importDefault(require("moment")); // 추후 moment로 변경. d.ts 변경 필요.\


var styles = tslib_1.__importStar(require("./DateRangePicker.style"));

var navIcons = tslib_1.__importStar(require("./navIcons"));

var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

var today = moment_1.default();
var focusedInputArray = tuple('startDate', 'endDate');
var orientationArray = tuple('horizontal', 'vertical', 'verticalScrollable');
var defaultDatePickerProps = {
  monthFormat: 'YYYY년 M월',
  weekDayFormat: 'ddd',
  hideKeyboardShortcutsPanel: true
};

function hideNavButton() {
  var _Array$from = Array.from(document.getElementsByClassName('DayPickerNavigation__vertical')),
      _Array$from2 = _slicedToArray(_Array$from, 1),
      calendarNav = _Array$from2[0];

  if (calendarNav) {
    calendarNav.setAttribute('style', 'display: none');
  }
}

var scrollObserver;

function disconnectObserver() {
  if (scrollObserver) {
    scrollObserver.disconnect();
  }
}

function setScrollEvent() {
  var targets = document.querySelectorAll('.CalendarMonth_caption');
  scrollObserver = new IntersectionObserver(function (entries) {
    if (!entries.length) {
      return;
    }

    if (entries[0].isIntersecting) {
      var _Array$from3 = Array.from(document.getElementsByClassName('DayPickerNavigation_button__vertical')),
          _Array$from4 = _slicedToArray(_Array$from3, 1),
          nextElement = _Array$from4[0];

      var nextButton = nextElement;
      nextButton.click();
      disconnectObserver();
      setScrollEvent();
    }
  });
  scrollObserver.observe(targets[targets.length - 1]);
}

var RangeDatePicker = function RangeDatePicker(_a) {
  var prices = _a.prices,
      startDate = _a.startDate,
      endDate = _a.endDate,
      numberOfMonths = _a.numberOfMonths,
      initialDate = _a.initialDate,
      orientation = _a.orientation,
      daySize = _a.daySize,
      onChange = _a.onChange,
      _a$minimumRangeDate = _a.minimumRangeDate,
      minimumRangeDate = _a$minimumRangeDate === void 0 ? null : _a$minimumRangeDate,
      maximumRangeDate = _a.maximumRangeDate,
      _a$minDate = _a.minDate,
      minDate = _a$minDate === void 0 ? null : _a$minDate,
      _a$maxDate = _a.maxDate,
      maxDate = _a$maxDate === void 0 ? null : _a$maxDate,
      otherOptions = tslib_1.__rest(_a, ["prices", "startDate", "endDate", "numberOfMonths", "initialDate", "orientation", "daySize", "onChange", "minimumRangeDate", "maximumRangeDate", "minDate", "maxDate"]);

  var _react_1$useState = react_1.useState(otherOptions.focusedInput || 'startDate'),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      focusedInput = _react_1$useState2[0],
      setFocusedInput = _react_1$useState2[1];

  function scrollToSelectedMonth() {
    var date = startDate || initialDate;
    var selectedMonth = moment_1.default(date).format('YYYY. M.');

    var selectedDay = _toConsumableArray(Array.from(document.querySelectorAll('.CalendarMonth_caption__verticalScrollable > strong'))).find(function (el) {
      return el.innerHTML === selectedMonth;
    });

    if (selectedDay) {
      selectedDay.scrollIntoView();
      var scrollContainer = document.querySelector('.DayPicker_transitionContainer__verticalScrollable');

      if (scrollContainer) {
        scrollContainer.scrollTop -= 60;
      }
    }
  }

  function isOutsideRange(day) {
    if (startDate !== null && maximumRangeDate !== null) {
      return day.isBefore(minimumRangeDate || today, 'day') || day.isAfter(maximumRangeDate, 'day');
    }

    return day.isBefore(today, 'day') || day.isBefore(minDate, 'day') || day.isAfter(maxDate, 'day');
  }

  react_1.useEffect(function () {
    if (orientation === 'verticalScrollable') {
      hideNavButton();
      setScrollEvent();

      if (initialDate) {
        scrollToSelectedMonth();
      }
    }

    return disconnectObserver;
  }, []);
  react_1.useEffect(function () {
    if (otherOptions.focusedInput) {
      setFocusedInput(otherOptions.focusedInput);
    }
  }, [otherOptions.focusedInput]);

  function handleDatesChange(_ref) {
    var startDate = _ref.startDate,
        endDate = _ref.endDate;
    onChange(startDate, endDate);
  }

  function handleFocusChange(focusedInput) {
    if (otherOptions.onFocusChange) {
      otherOptions.onFocusChange(focusedInput);
    } else {
      setFocusedInput(focusedInput === null ? 'startDate' : focusedInput);
    }
  }

  var initialVisibleMonth = function initialVisibleMonth() {
    return moment_1.default(initialDate);
  };

  var containerStyle = orientation === 'verticalScrollable' ? [styles.container, styles.vertical, styles.override, styles.overrideVertical] : [styles.container, styles.override, styles.overrideHorizontal];

  var renderDayContents = function renderDayContents(day) {
    var isStart = day.isSame(startDate, 'day');
    var isEnd = day.isSame(endDate, 'day');
    var isBetween = day.isBetween(startDate, endDate, 'day');
    var isToday = day.isSame(today, 'day') && !isStart && !isEnd;
    return jsx_runtime_1.jsxs(react_1.Fragment, {
      children: [isStart && jsx_runtime_1.jsx("div", {
        css: styles.selected('start')
      }, void 0), isEnd && jsx_runtime_1.jsx("div", {
        css: styles.selected('end')
      }, void 0), jsx_runtime_1.jsx("div", Object.assign({
        css: [styles.day(isStart || isEnd), isBetween && styles.between, isToday && styles.today]
      }, {
        children: day.format('D')
      }), void 0)]
    }, void 0);
  };

  return jsx_runtime_1.jsx("div", Object.assign({
    css: containerStyle
  }, {
    children: jsx_runtime_1.jsx(react_dates_1.DayPickerRangeController, Object.assign({}, defaultDatePickerProps, {
      startDate: startDate,
      endDate: endDate,
      focusedInput: focusedInput,
      isOutsideRange: isOutsideRange,
      initialVisibleMonth: initialVisibleMonth,
      numberOfMonths: numberOfMonths,
      orientation: orientation,
      daySize: daySize,
      minDate: minDate !== null && minDate !== void 0 ? minDate : today,
      maxDate: maxDate,
      navPrev: jsx_runtime_1.jsx("img", {
        css: styles.navPrev,
        src: navIcons.leftHover,
        alt: "\uC774\uC804 \uB2EC\uB85C \uC774\uB3D9"
      }, void 0),
      navNext: jsx_runtime_1.jsx("img", {
        css: styles.navNext,
        src: navIcons.rightHover,
        alt: "\uB2E4\uC74C \uB2EC\uB85C \uC774\uB3D9"
      }, void 0),
      renderDayContents: renderDayContents,
      onDatesChange: handleDatesChange,
      onFocusChange: handleFocusChange,
      verticalHeight: 800
    }, otherOptions), void 0)
  }), void 0);
};

exports.default = RangeDatePicker;
RangeDatePicker.defaultProps = {
  startDate: null,
  endDate: null,
  numberOfMonths: 1,
  initialDate: moment_1.default(),
  orientation: 'horizontal',
  onChange: function onChange() {
    return null;
  },
  prices: []
};